export enum GoalTypeEnum {
    SHARE_POSITIVE_NEWS = 'SHARE_POSITIVE_NEWS',
    SHARE_NEGATIVE_NEWS = 'SHARE_NEGATIVE_NEWS',
    FRAME_NEWS_POSITIVELY = 'FRAME_NEWS_POSITIVELY',
    FRAME_NEWS_NEGATIVELY = 'FRAME_NEWS_NEGATIVELY',
    ENHANCE_BRAND_REPUTATION = 'ENHANCE_BRAND_REPUTATION',
    IMPACT_ANALYSIS = 'IMPACT_ANALYSIS',
    POSITION_ME_AS_THOUGHT_LEADER = 'POSITION_ME_AS_THOUGHT_LEADER',
    RELAY_FACTS_AND_FIGURES = 'RELAY_FACTS_AND_FIGURES',
    INSPIRE_AUDIENCE = 'INSPIRE_AUDIENCE',
    EDUCATE_AUDIENCE = 'EDUCATE_AUDIENCE',
    BUILD_COMMUNITY = 'BUILD_COMMUNITY',
    CALL_TO_ACTION = 'CALL_TO_ACTION',
    NETWORK_AND_BUILD_RELATIONSHIPS = 'NETWORK_AND_BUILD_RELATIONSHIPS',
    MAKE_PREDICTIONS = 'MAKE_PREDICTIONS',
    CURATE_RELATED_INFO = 'CURATE_RELATED_INFO',
    THOUGHT_PROVOCATION = 'THOUGHT_PROVOCATION',
};
